// pair to native DOM events, see https://mdn.io/video
// NOTE: 补充新类型时，应当在 `EventParamsMap` 中定义参数类型
var DOM;
(function (DOM) {
    DOM["PLAY"] = "event/dom/play";
    DOM["PLAYING"] = "event/dom/playing";
    DOM["PAUSE"] = "event/dom/pause";
    DOM["ENDED"] = "event/dom/ended";
    DOM["TIMEUPDATE"] = "event/dom/timeupdate";
    DOM["ERROR"] = "event/dom/error";
    DOM["WAITING"] = "event/dom/waiting";
    DOM["CANPLAY"] = "event/dom/canplay";
    DOM["LOADEDDATA"] = "event/dom/loadeddata";
    DOM["PROGRESS"] = "event/dom/progress";
})(DOM || (DOM = {}));
// custom events
// NOTE: 补充新类型时，应当在 `EventParamsMap` 中定义参数类型
var PLAYER$1;
(function (PLAYER) {
    PLAYER["QUALITY_CHANGE"] = "event/player/quality-change";
    PLAYER["CHANGE_QUALITY_START"] = "event/player/quality-change-start";
    PLAYER["CHANGE_QUALITY_SUCCESS"] = "event/player/quality-change-success";
    PLAYER["CHANGE_QUALITY_FAIL"] = "event/player/quality-change-fail";
    PLAYER["PLAYBACK_RATE_CHANGE"] = "event/player/rate-change";
    PLAYER["REQUEST_PLAY"] = "event/player/request-play";
    PLAYER["PLAY_REJECTED"] = "event/player/play-rejected";
    PLAYER["REQUEST_PAUSE"] = "event/player/request-pause";
    PLAYER["PLAY_COUNT"] = "event/player/play-count";
    PLAYER["PLAY_FAILED"] = "event/player/play-failed";
    PLAYER["ENTER_FULLSCREEN"] = "event/player/enter-fullscreen";
    PLAYER["EXIT_FULLSCREEN"] = "event/player/exit-fullscreen";
    PLAYER["ENTER_PAGE_FULLSCREEN"] = "event/player/enter-page-fullscreen";
    PLAYER["EXIT_PAGE_FULLSCREEN"] = "event/player/exit-page-fullscreen";
    PLAYER["ENTER_PIP"] = "event/player/enter-pip";
    PLAYER["EXIT_PIP"] = "event/player/exit-pip";
    PLAYER["SHOW_CONTROLLER"] = "event/player/show-controller";
    PLAYER["HIDE_CONTROLLER"] = "event/player/hide-controller";
    PLAYER["HOVER_PROGRESS_DOT"] = "event/player/hover-progress-dot";
    PLAYER["LEAVE_PROGRESS_DOT"] = "event/player/leave-progress-dot";
    PLAYER["SUBSCRIPTION_READY"] = "event/player/subscription-ready";
})(PLAYER$1 || (PLAYER$1 = {}));
// TODO：临时兼容，下一版本删除，直接在定义上合并，否则造成引用上的麻烦
const EVENTS = Object.assign(Object.assign(Object.assign({}, DOM), PLAYER$1), { 
    /** @deprecated Please use `EVENTS.NAME` instead */ DOM,
    /** @deprecated Please use `EVENTS.NAME` instead */ PLAYER: PLAYER$1 });

// NOTE: 补充新类型时，应当在 `ActionParamsMap` 中定义参数类型
var PLAYER;
(function (PLAYER) {
    PLAYER["PLAY"] = "action/player/play";
    PLAYER["PAUSE"] = "action/player/pause";
    PLAYER["SET_VOLUME"] = "action/player/set-volume";
    PLAYER["ENTER_FULLSCREEN"] = "action/player/enter-fullscreen";
    PLAYER["EXIT_FULLSCREEN"] = "action/player/exit-fullscreen";
    PLAYER["ENTER_PAGE_FULLSCREEN"] = "event/player/enter-page-fullscreen";
    PLAYER["EXIT_PAGE_FULLSCREEN"] = "event/player/exit-page-fullscreen";
    PLAYER["ENTER_PIP"] = "action/player/enter-pip";
    PLAYER["EXIT_PIP"] = "action/player/exit-pip";
    PLAYER["TIME_UPDATE"] = "action/player/time-update";
    PLAYER["SHOW_CONTROLLER"] = "action/player/show-controller";
})(PLAYER || (PLAYER = {}));
// TODO：临时兼容，下一版本删除，直接在定义上合并，否则造成引用上的麻烦
const ACTIONS = Object.assign(Object.assign({}, PLAYER), { 
    /** @deprecated Please use `ACTIONS.NAME` instead */
    PLAYER });

const LIB_ID = 'griffith';
/**
 * 创建一个消息管理器
 *
 * @example
 *
 * ```ts
 * import {createMessageHelper, EVENTS, ACTIONS} from 'griffith-message'
 *
 * const helper = createMessageHelper()
 * // register event listener
 * helper.subscribeMessage(EVENTS.PLAY, r => { r.currentTime })
 * helper.subscribeMessage(EVENTS.QUALITY_CHANGE, r => { r.quality })
 * // dispatch action to player
 * helper.dispatchMessage(window, ACTIONS.SET_VOLUME, {volume: .5})
 * // dispose all event listeners
 * helper.dispose()
 * ```
 *
 * @param id 唯一 id，传出消息会带着这个 id
 * @param targetOrigin 对应窗口的域名，不传或者传 * 表示不限制
 * @param shouldValidateId 是否验证传入消息的 id 和自身 id 相同
 */
function createMessageHelper(id, targetOrigin = '*', shouldValidateId = false) {
    const disposers = new Set();
    function subscribeMessage(arg1, arg2) {
        const isLegacy = typeof arg1 === 'function';
        const handler = isLegacy ? arg1 : arg2;
        const eventName = isLegacy ? undefined : arg1;
        function realHandler(event) {
            // 限制消息来源 @see https://developer.mozilla.org/zh-CN/docs/Web/API/Window/postMessage#The_dispatched_event
            const origin = event.origin;
            const originIsValidated = targetOrigin === '*' || targetOrigin === origin;
            const { from, id: incomingId, payload } = event.data || {};
            const idIsValidated = !shouldValidateId || id === incomingId;
            if (originIsValidated && from === LIB_ID && idIsValidated && payload) {
                const { name, data } = payload;
                if (!name || typeof handler !== 'function') {
                    return;
                }
                if (isLegacy) {
                    handler(name, data, event.source);
                }
                else if (eventName === name) {
                    handler(data, event.source);
                }
            }
        }
        window.addEventListener('message', realHandler);
        const disposer = {
            unsubscribe: () => {
                window.removeEventListener('message', realHandler);
                disposers.delete(disposer);
            },
        };
        disposers.add(disposer);
        return disposer;
    }
    /**
     * Dispose all registered event listeners.
     */
    const dispose = () => {
        disposers.forEach((x) => x.unsubscribe());
    };
    /**
     * Dispatch action to player
     */
    const dispatchMessage = (target, name, ...data) => {
        var _a;
        (_a = target === null || target === void 0 ? void 0 : target.postMessage) === null || _a === void 0 ? void 0 : _a.call(target, { from: LIB_ID, id, payload: { name, data: data[0] } }, targetOrigin || '*');
    };
    return {
        subscribeMessage,
        dispatchMessage,
        dispose,
    };
}

export { ACTIONS, EVENTS, createMessageHelper };
